// extracted by mini-css-extract-plugin
export default {"slide":"beforeAfter_slide__kYM6l","image":"beforeAfter_image__armzK","side":"beforeAfter_side__I7HPV","label":"beforeAfter_label__C-bWn"};